export default "__VITE_ASSET__CJjkPVEw__"